module.exports = __webpack_public_path__ + "img/Gargalhada_Corpo_1.4e632bc2.png";